import {
    Flex
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BoxSchemeControl } from "../parts/BoxSchemeControl";
import { AppMenuButtons } from "../parts/AppMenuButtons";

import bgimg from "../images/box/box.webp";
import bgvid from "../videos/box.mp4";
import { Helmet } from "react-helmet";
import { BoxModeToggle } from "../parts/BoxModeToggle";

function App() {

    const [is3DMode, setIs3DMode] = useState(true);

    useEffect(() => {
        document.title = "Box Generator";
    });

    useEffect(() => {
        const savedMode = localStorage.getItem("boxSchemeMode");
        if (savedMode === "2d") {
            setIs3DMode(false);
        } else {
            setIs3DMode(true);
        }
    }, []);

    useEffect(() => {
        localStorage.setItem("boxSchemeMode", is3DMode ? "3d" : "2d");
    }, [is3DMode]);

    return (
        <Flex h="100vh" w="100vw">
            <Helmet>
                <meta name="description" content={"A prototyping tool to generate box schemes for laser cutters."} />
            </Helmet>
            <BoxSchemeControl
                position="fixed"
                w={["auto", "auto", "560px"]}
                left="12px"
                right={["12px", "12px"]}
                bottom={"12px"}
                is3DMode={is3DMode}
            />
            <AppMenuButtons pageLabel="Laser" appVersion="0.2.6" modalHeader="About Box Generator" customComponent={<BoxModeToggle is3DMode={is3DMode} onToggle={setIs3DMode} />}>
                <p>This is a tool to generate box patterns for laser cutters and 3D printers.</p>
                <br />
                <p>Input the dimensions of the box and optional parameters, and save the file either as SVG (for laser cutters) or STL (for 3D printers).</p>
                <br />
                <p>This tool works locally in the browser and does not store any data in the server.</p>
                <br />
                <video autoPlay muted loop playsInline poster={bgimg}>
                    <source src={bgvid} type="video/mp4" />
                </video>
                <center><small><p>An example card tray with 2 adjustable dividers, laser cutter mode.</p></small></center>
            </AppMenuButtons>
        </Flex>

    );
}

export default App;
